module.exports = __webpack_public_path__ + "img/17.47ab991d.jpg";